import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        {/* Imagine section */}
        <div className="text-center mb-10" data-id="element-157">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4 font-['Oswald'] uppercase" data-id="element-158">
            ✨ Imagina esto…
          </h2>
          <p className="text-lg text-gray-700 max-w-lg mx-auto mb-2" data-id="element-159">
            Tu hijo sentado, concentrado… mirando, explorando y diciendo:
          </p>
          <p className="text-xl md:text-2xl font-bold text-[#2980b9] italic" data-id="element-160">
            "¡Mira! Ya entendí cómo funciona esto"
          </p>
          <p className="text-base text-gray-500 mt-3" data-id="element-161">
            Eso es lo que pasa cuando aprende de la forma correcta.
          </p>
        </div>

        {/* What is this pack */}
        <div className="bg-blue-50 rounded-xl p-6 md:p-8 border-2 border-blue-200" data-id="element-162">
          <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-4 font-['Oswald'] uppercase text-center" data-id="element-163">
            🎯 ¿Qué es este pack?
          </h3>
          <p className="text-base text-gray-700 text-center mb-6" data-id="element-164">
            Un sistema educativo visual diseñado para que los niños:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto" data-id="element-165">
            {['Comprendan cómo funciona el cuerpo humano', 'Aprendan de forma clara, visual y entretenida', 'Despierten su curiosidad natural', 'Se interesen más por aprender cada día'].map((item, idx) => <div key={idx} className="flex items-start gap-2 bg-white p-3 rounded-lg" data-id="element-166">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-167" />
                <span className="text-sm font-medium text-gray-800" data-id="element-168">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}